import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { faTrashAlt, faPencilAlt } from '@fortawesome/free-solid-svg-icons';
import { Subscription } from 'rxjs';
import { Alert } from 'src/app/classes/alert';
import { AbstractService } from 'src/app/services/abstract.service';
import { AlertboxComponent } from '../alertbox/alertbox.component';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { Pagination } from 'src/app/classes/pagination';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-list-crest',
  templateUrl: './list-crest.component.html',
  styleUrls: ['./list-crest.component.scss'],
})
export class ListCrestComponent implements OnInit{
  faPencilAlt = faPencilAlt
  faTrashAlt = faTrashAlt
  busy: Subscription;
  result: any;
  @Input() list;
  @Input() paginationItems: Pagination;
  @Input() cols: string[];
  @Input() componentService: AbstractService;
  @Input() routePart: string;
  @Input() itemType: string = '';
  @Output() reloadList = new EventEmitter<string>();
  @Output() page = new EventEmitter<number>();
  @ViewChild('alertbox1', { static: false }) alertbox1: AlertboxComponent;

  returnedArray: string[];
  showBoundaryLinks: boolean = true;
  showDirectionLinks: boolean = true;
  rotate = false;
  maxSize = 8;
  constructor(private router: Router) { }





  ngOnInit(): void { 
    
   }


  ngOnChanges(changes: SimpleChanges) {
    // changes.prop contains the old and the new value...
    if (this.list){
      this.returnedArray = this.list.payload.slice(0, 50);
    }
  }


  pageChanged(event: PageChangedEvent): void {
    this.page.emit(event.page);

 }

  add(a: Alert) {
    this.alertbox1.alerts.push(a);
  }
  
  deleteItem(id: number) {
    if (+id > 0) {
      this.busy = this.componentService.delete(id).subscribe({
        next: () => {
          this.reloadList.emit();
        },
        error: (err) => console.log(err),
      });
    }
  }

  navigateTo(id: any) {
    console.log(id)
    this.router.navigate([`/${this.routePart}/${id}`]);
  }

  dialogConfirm(id) {
    console.log(id);
    if (+id > 0) {
      this.deleteItem(id);
    }
  }
  

}
